const prefix = 'fasr';
const iconName = 'align-left';
const width = 448;
const height = 512;
const aliases = [];
const unicode = 'f036';
const svgPathData = 'M24 40H0V88H24 264h24V40H264 24zm0 128H0v48H24 424h24V168H424 24zM0 296v48H24 264h24V296H264 24 0zM24 424H0v48H24 424h24V424H424 24z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
